import { render, staticRenderFns } from "./ContactsFacebook.vue?vue&type=template&id=2cb8361e&scoped=true&"
import script from "./ContactsFacebook.vue?vue&type=script&lang=js&"
export * from "./ContactsFacebook.vue?vue&type=script&lang=js&"
import style0 from "./ContactsFacebook.vue?vue&type=style&index=0&id=2cb8361e&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb8361e",
  null
  
)

export default component.exports